export default __webpack_public_path__ + "static/media/breakthrough.e894deae.jpg";